<div class="notification-type">
  <div class="config-header">
    <h3>Configure Group Notification</h3>
  </div>

  @if (currentNotification()) {
    <div class="main-content">
      <div class="columns">
        <div class="column is-3">
          <span>Notification Type</span>
        </div>
        <div class="column is-5 field">
          <div class="control">
            <div class="select">
              <select [(ngModel)]="currentNotification().notificationType" [compareWith]="this.compareFn"
                (change)="notificationTypeChanged()" [disabled] ="isEditingDisabled()">
                <option value=null selected>-- Select --</option>
                @for (nType of notificationTypesList; track nType) {
                  <option [ngValue]="nType">
                    {{nType.value}}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="column"></div>
      </div>
      @if (isValidNotificationSelected()) {
        <div>
          <!---   EVENTS -->
          @if (shouldShowEvents()) {
            <div class="columns">
              <div class="column is-3">
                <span>Schema Event</span>
              </div>
              @if (shouldShowEvents()) {
                <div class="column is-5 field">
                  <!--     *ngIf="isTypeConfirmation()"> -->
                  <ul>
                    @for (evt of displayEvents; track evt; let rowIdx = $index) {
                      <li>
                        <label class="checkbox" >
                          <input type="checkbox" name="regEvt-{{rowIdx}}"
                            (click)="eventSelectionClicked()" [(ngModel)]="selectedEventList[rowIdx]" [disabled] ="isEditingDisabled()">
                            {{evt.name}}
                          </label>
                        </li>
                      }
                    </ul>
                  </div>
                }
                <div class="column"></div>
              </div>
            }
            <!--- EVENTS -->
            @if (isTypeApproval()) {
              <div class="columns is-horizontal">
                <div class="column is-3 ">
                  <span>Notify At</span>
                </div>
                <div class="column is-4 field">
                  <ul>
                    @for (apprType of approvalTypesList; track apprType) {
                      <li>
                        <label class="checkbox" >
                          <input type="checkbox"
                            [ngModel]="isSelected(apprType)"
                            (ngModelChange)="toggleSelection($event, apprType)" [disabled] ="isEditingDisabled()">
                            {{apprType.desc}}
                          </label>
                        </li>
                      }
                    </ul>
                  </div>
                </div>
              }
              @if (isTypeAccrual() || isTypeRandomizationCheck()) {
                <div class="columns is-horizontal">
                  <div class="column is-3 ">
                    <span>Notify At</span>
                  </div>
                  <div class="column is-4 field">
                    <div class="control">
                      <div class="select">
                        <select [(ngModel)]="currentNotification().notificationAccrualDetail.accrualPointType" [compareWith]="this.compareFn" [disabled] ="isEditingDisabled()">
                          <option value=null selected>-- Select --</option>
                          @for (nType of accrualPointsList; track nType) {
                            <option [ngValue]="nType">
                              {{nType.value}}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="column"></div>
                  @if (currentNotification().notificationAccrualDetail.accrualPointType && currentNotification().notificationAccrualDetail.accrualPointType.value === 'Every (x) Patients') {
                    <div class="column is-8">
                      <div class="columns">
                        <span class="column is-3">For Every:</span>
                        <div class="column ">
                          <div class="field is-horizontal">
                            <div class="control ">
                              <input class="form-control input" placeholder="number" id="for-every" name="forEvery" [(ngModel)]="currentNotification().notificationAccrualDetail.accrualPoint" [disabled] ="isEditingDisabled()">
                            </div>&nbsp;&nbsp;
                            <span>Patients</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (currentNotification().notificationAccrualDetail.accrualPointType && currentNotification().notificationAccrualDetail.accrualPointType.value === 'a (%) of Patients') {
                    <div class="column is-8">
                      <div class="columns">
                        <div class="column">
                          <div class="field is-horizontal">
                            <div class="control ">
                              <input class="form-control input" placeholder="number" id="percent" name="percent" [(ngModel)]="currentNotification().notificationAccrualDetail.accrualPoint" [disabled] ="isEditingDisabled()">
                            </div>&nbsp;&nbsp;
                            <span>%</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (currentNotification().notificationAccrualDetail.accrualPointType && currentNotification().notificationAccrualDetail.accrualPointType.value === '(xth) Patient') {
                    <div class="column is-8">
                      <div class="columns">
                        <div class="column is-4">
                          <div class="field is-horizontal">
                            <div class="control ">
                              <input class="form-control input" placeholder="number" id="xth-patient" name="xthPatient" [(ngModel)]="currentNotification().notificationAccrualDetail.accrualPoint" [disabled] ="isEditingDisabled()">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
          <!---- audit notification -------->
          @if (isTypeAudit()) {
            <div class="columns is-horizontal">
              <div class="column is-3">
                <span>Schema Event</span>
              </div>
              <!--
              [checked]="currentNotification().groupNotificationEventList[0] && currentNotification().groupNotificationEventList[0].codeId == auditEvt.codeId" -->
              <div class="column is-5 field">
                <ul>
                  @for (auditEvt of displayAuditEvents; track auditEvt) {
                    <li >
                      <label class="radio">
                        <input type="radio"
                          name="auditEvent"
                          [(ngModel)]="currentNotification().groupNotificationEventList[0].codeId"
                          [value]="auditEvt.codeId"
                          (click)="auditEventSelectionClicked(auditEvt)"
                          [disabled]="isEditingDisabled()">
                          {{auditEvt.name}}
                        </label>
                      </li>
                    }
                  </ul>
                </div>
                <div class="column"></div>
              </div>
            }
            @if (isTypeAudit()) {
              <div class="columns is-horizontal">
                <div class="column is-3">
                  <span>By Level</span>
                </div>
                <!--[checked]="currentNotification().notificationAccrualDetail.notificationByLevel  && currentNotification().notificationAccrualDetail.notificationByLevel.id == lvl.id"-->
                <div class="column is-5 field">
                  <ul>
                    @for (lvl of displayAuditLevels; track lvl) {
                      <li >
                        <label class="radio">
                          <input type="radio"
                            name="auditLevel"
                            [(ngModel)]="currentNotification().notificationAccrualDetail.notificationByLevel.id"
                            [value]="lvl.id"
                            (click)="auditLevelSelectionClicked(lvl)"
                            [disabled]="isEditingDisabled()">
                            {{lvl.value}}
                          </label>
                        </li>
                      }
                    </ul>
                  </div>
                  <div class="column"></div>
                </div>
              }
              <!---- audit notification -------->
              <div class="columns ">
                <div class=" column is-3 ">
                  <div class=" field is-horizontal ">
                    <span>Notes</span>
                  </div>
                </div>
                <div class="column is-7 ">
                  <div class="field is-horizontal ">
                    <div class="field-body text-field-padding ">
                      <div class="field ">
                        <div class="control ">
                <textarea placeholder="Notes " name="notes " id="body " class="textarea width-100-percent " rows="6
        " [(ngModel)]="currentNotification().notes " [disabled]="isEditingDisabled()"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>